'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _hasLiveChatAttachments = require('conversations-schema/pubnub-message/operators/hasLiveChatAttachments');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThreadPreviewText = function (_Component) {
  _inherits(ThreadPreviewText, _Component);

  function ThreadPreviewText() {
    _classCallCheck(this, ThreadPreviewText);

    return _possibleConstructorReturn(this, (ThreadPreviewText.__proto__ || Object.getPrototypeOf(ThreadPreviewText)).apply(this, arguments));
  }

  _createClass(ThreadPreviewText, [{
    key: 'renderText',
    value: function renderText() {
      var text = (0, _commonMessageFormatGetters.getPlainText)(this.props.latestMessage);
      var hasAttachment = (0, _hasLiveChatAttachments.hasLiveChatAttachments)(this.props.latestMessage);

      if (!hasAttachment) {
        return text;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_UIIcon2.default, { className: 'm-right-2', name: 'attach' }),
        text || _react2.default.createElement(_FormattedMessage2.default, { message: 'cvVisitorUIAttachments.threadPreview' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UITruncateString2.default,
        {
          className: (0, _classNames2.default)(this.props.className, 'latest-message-text', {
            'is--heading-7': !!this.props.unseenCount
          }),
          tooltip: false
        },
        this.renderText()
      );
    }
  }]);

  return ThreadPreviewText;
}(_react.Component);

ThreadPreviewText.displayName = 'ThreadPreviewText';

ThreadPreviewText.propTypes = {
  className: _react.PropTypes.string,
  latestMessage: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('PubNubMessageRecord'), (0, _RecordPropType2.default)('CommonMessage')]).isRequired,
  unseenCount: _react.PropTypes.number.isRequired
};

exports.default = ThreadPreviewText;
module.exports = exports['default'];